export default __webpack_public_path__ + "static/media/action-card-liquidity-mining-usdt-dfi.e7e33837.svg";